import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../../data/images';
import { FaSearchPlus } from 'react-icons/fa';

export default function TimelineImage({ year, onImageClick }) {
  // Special handling for 1965 with multiple images
  if (year === 1964) {
    return (
      <motion.div
        key={year}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.3 }}
        className="grid grid-cols-2 gap-4"
      >
        {[
          IMAGES.timeline[1964].first,
          'https://i.postimg.cc/zXNjbxbp/1964.png'
        ].map((imageUrl, index) => (
          <div
            key={index}
            className="relative aspect-[4/3] rounded-xl overflow-hidden group cursor-pointer"
            onClick={() => onImageClick(imageUrl, `Benny's Pølsevogn 1964 - ${index + 1}`)}
          >
            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" />

            {/* Image */}
            <motion.img
              src={imageUrl}
              alt={`Benny's Pølsevogn 1964 - ${index + 1}`}
              className="w-full h-full object-cover"
              initial={{ scale: 1.1 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5 }}
            />

            {/* Zoom Button */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20
                         bg-white/90 p-4 rounded-full opacity-0 group-hover:opacity-100
                         transition-opacity duration-300 hover:bg-white">
              <FaSearchPlus className="w-6 h-6 text-primary" />
            </div>
          </div>
        ))}
      </motion.div>
    );
  }

  // Default single image display for other years
  const imageUrl = IMAGES.timeline[year];

  return (
    <motion.div
      key={year}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.3 }}
      className="relative aspect-[4/3] rounded-xl overflow-hidden group cursor-pointer"
      onClick={() => onImageClick(imageUrl, `Benny's Pølsevogn ${year}`)}
    >
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10" />
      <motion.img
        src={imageUrl}
        alt={`Benny's Pølsevogn ${year}`}
        className="w-full h-full object-cover"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5 }}
      />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20
                   bg-white/90 p-4 rounded-full opacity-0 group-hover:opacity-100
                   transition-opacity duration-300 hover:bg-white">
        <FaSearchPlus className="w-6 h-6 text-primary" />
      </div>
    </motion.div>
  );
}